import { CPCard } from "@warden-ui/common-components";
import { DigitCodeInput } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

interface CardContentResetPasswordCodeProps {
  email: string;
  teamDomain: string;
  onClickSendCode?: (verificationCode: string) => void;
  errorMessage?: string;
  loading?: boolean;
}

export const CardContentResetPasswordCode = ({
  email,
  teamDomain,
  onClickSendCode = () => {},
  ...props
}: CardContentResetPasswordCodeProps ) => {
  const { t } = useTranslation();

  return (
    <CPCard>
      <DigitCodeInput
        title={t('digit_code.title')}
        hint={t('digit_code.hint', { email })}
        labelButton={t('buttons.next')}
        onClick={onClickSendCode}
        errorMessage={props.errorMessage}
        loading={props.loading}
      />
    </CPCard>
  );
};
